import client from "~/apis/client"

export function fetchCleanerPortal(token) {
  return client.get(`/cleaner_portal/${token}`)
}

export function acceptClean(token, cleanId) {
  return client.patch(`/cleaner_portal/${token}/cleans/${cleanId}/accept`)
}

export function declineClean(token, cleanId) {
  return client.patch(`/cleaner_portal/${token}/cleans/${cleanId}/decline`)
}

export function completeClean(token, cleanId, { conditionOk, conditionNotes } = {}) {
  return client.patch(`/cleaner_portal/${token}/cleans/${cleanId}/complete`, {
    condition_ok: conditionOk, condition_notes: conditionNotes,
  })
}

// "Cleaner to confirm" cleans: lock in a day (and optional HH:MM time).
export function chooseCleanDate(token, cleanId, { onDate, time }) {
  return client.patch(`/cleaner_portal/${token}/cleans/${cleanId}/choose`, { on_date: onDate, time })
}

export function updateShoppingNote(token, cleanId, shoppingNote) {
  return client.patch(`/cleaner_portal/${token}/cleans/${cleanId}/shopping_note`, { shopping_note: shoppingNote })
}

// cleanId is optional: a note can be about the property in general.
export function createCleanerNote(token, { cleanId, kind, body }) {
  return client.post(`/cleaner_portal/${token}/notes`, { clean_id: cleanId, kind, body })
}
